import { reduxForm } from 'redux-form';
import Component from './FormAddBusinessType.jsx';
import { initialValues, validate } from './validate';

export default reduxForm({
  form: 'FormAddBusinessType',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);
